<template>
  <a
    v-if="donwloadUrl && !isChannel"
    :href="donwloadUrl"
    target="_blank"
    :class="$style.download"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BtnDownload',
  computed: {
    ...mapGetters(['donwloadUrl', 'isChannel'])
  }
}
</script>

<style module lang="less">
.download {
  .size(1.29rem, 0.43rem);
  .background-fill('./images/btn-download.png');
}
</style>
